import egumaReact from "egumaReact"; // added in externals in webpack
import React from "react";
import { DayPickerSingleDateController } from "react-dates";

import { Element } from "react-scroll";
import Error from "../Components/Error";

import moment from "moment";
import "../Lib/moment-locales";

import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "./react_dates_overrides.css";
import { scroller } from "react-scroll";
import { DotLoader } from "react-spinners";
import Tickets from "./Tickets";
import TicketsAccordion from "./TicketsAccordion";
import TimeSlots from "./TimeSlots";
import Capacities from "./Capacities";
import Note from "../Components/Note";

import Polyglot from "node-polyglot";
import PromocodeForm from "../Components/PromocodeForm";
import { PrimaryButton } from "../Components/Button";
import client from "../Lib/client";
const polyglot = new Polyglot({ phrases: egumaReact.translations });

const delay = () =>
  new Promise(resolve => {
    return setTimeout(() => resolve(), 500);
  });

class App extends React.Component {
  constructor(props) {
    super(props);

    // display "monday" as first day of week for en locale
    moment.updateLocale("en", {
      week: {
        dow: 1
      }
    });

    moment.locale(egumaReact.lang);

    this.refNote = React.createRef();

    this.state = {
      availableDates: new Set([...egumaReact.availableDates]),
      date:
        egumaReact.date !== null ? moment(egumaReact.date, "DD-MM-YYYY") : null,
      error: null,
      entirelyBookedDates: new Set([...egumaReact.entirelyBookedDates]),
      fetchingDates: false,
      fetchingTickets: false,
      fetchingTimeSlots: false,
      fetchingCapacities: false,
      selectedTickets: {},
      groups: [],
      selectedTimeSlot: null,
      tickets: [],
      timeSlots: [],
      capacities: [],
      selectedCapacity: null,
      newTickets: []
    };
  }

  componentDidMount = () => {
    if (this.state.date !== null) {
      this.onChangeDate(this.state.date, false);
    }
  };

  getDates = async month => {
    this.setState({
      fetchingDates: true
    });

    const payload = {
      shortId: egumaReact.shortId,
      dateTime: month.toISOString()
    };
    const url = `/api/${egumaReact.mandantId}/${egumaReact.lang}/get_dates`;

    try {
      const response = client(url, { body: payload });

      const [{ availableDates, entirelyBookedDates }] = await Promise.all([
        response,
        delay()
      ]);

      this.setState({
        availableDates: new Set([
          ...availableDates,
          ...this.state.availableDates
        ]),
        entirelyBookedDates: new Set([
          ...entirelyBookedDates,
          ...this.state.entirelyBookedDates
        ]),
        fetchingDates: false
      });
    } catch (error) {
      console.log(error);
      this.setState({ fetchingDates: false });
    }
  };

  onChangeDate = (date, scrollTo = true) => {
    this.setState({ date, newTickets: [] }, () => {
      this.getTimeSlots(scrollTo);
      const updatedUrl = new URL(window.location.href);
      const formattedDate = moment(date).format("DD-MM-YYYY");
      updatedUrl.searchParams.set("date", formattedDate);
      window.history.replaceState(
        { date: formattedDate },
        "",
        updatedUrl.toString()
      );
    });
  };

  getTickets = async (
    { slotId, capacityId = null, resetNewTickets = true },
    scrollTo = true
  ) => {
    this.setState({
      error: null,
      fetchingTickets: true,
      selectedTimeSlot: slotId,
      selectedCapacity: capacityId,
      selectedTickets: {},
      tickets: []
    });

    const payload = {
      shortId: egumaReact.shortId,
      slotId,
      capacityId
    };

    const url = `/api/${egumaReact.mandantId}/${egumaReact.lang}/get_ticket_types`;

    try {
      const { tickets, groups } = await client(url, { body: payload });

      var selectedTickets = {};

      tickets.forEach(ticket => {
        if (ticket.quantities.length > 0 && ticket.quantities[0] > 0) {
          selectedTickets[ticket.id] = ticket.quantities[0];
        }
      });

      this.setState({ selectedTickets: selectedTickets, groups });

      this.setState({ fetchingTickets: false, tickets }, () => {
        if (scrollTo) {
          scroller.scrollTo("tickets", {
            duration: 300,
            smooth: true,
            offset: -20
          });
        }
      });

      if (resetNewTickets) {
        this.setState({ newTickets: [] });
      }
    } catch (error) {
      console.log(error);
      this.setState({ fetchingTickets: false, tickets: [] });
    }
  };

  getCapacities = async ({ slotId }, scrollTo = true) => {
    this.setState({
      error: null,
      fetchingTickets: true,
      selectedTimeSlot: slotId,
      selectedTickets: {},
      tickets: [],
      selectedCapacity: null
    });

    const payload = {
      slotId,
      shortId: egumaReact.shortId
    };

    const url = `/api/${egumaReact.mandantId}/${egumaReact.lang}/get_capacities`;

    try {
      const { capacities } = await client(url, { body: payload });

      if (capacities.length === 1) {
        this.setState({ selectedCapacity: capacities[0].id });
        this.getTickets({ slotId, capacityId: capacities[0].id }, scrollTo);
      }

      this.setState({ capacities }, () => {
        if (scrollTo) {
          scroller.scrollTo("capacities", {
            duration: 300,
            smooth: true,
            offset: -20
          });
        }
      });
    } catch (error) {
      console.log(error);
      this.setState({ fetchingTickets: false, tickets: [] });
    }
  };

  getTimeSlots = async (scrollTo = true) => {
    this.setState({
      error: null,
      fetchingTimeSlots: true,
      selectedTimeSlot: null,
      timeSlots: [],
      tickets: []
    });
    const payload = {
      shortId: egumaReact.shortId,
      date: this.state.date.format("YYYY-MM-DD")
    };

    const url = `/api/${egumaReact.mandantId}/${egumaReact.lang}/get_time_slots`;

    try {
      const { timeSlots, isPurchaseClosed } = await client(url, {
        body: payload
      });

      this.setState({ fetchingTimeSlots: false, timeSlots }, () => {
        if (egumaReact.isAllDay && !egumaReact.hasMultipleCapacities) {
          if (timeSlots.length === 0) {
            this.setState(
              {
                error:
                  !isPurchaseClosed && egumaReact.userCanEnterPromocode
                    ? polyglot.t("Shop.Error.NoTicketsAvailablePromocode")
                    : polyglot.t("Shop.Calendar.NoTicketsAvailableForThisDay")
              },
              () => {
                scroller.scrollTo("error", {
                  duration: 300,
                  smooth: true,
                  offset: -20
                });
              }
            );
            return;
          }
          this.getTickets(
            {
              slotId: timeSlots[0].id,
              capacityId: timeSlots[0].capacities[0]
            },
            scrollTo
          );
          this.setState({ selectedTimeSlot: timeSlots[0].id });
          return;
        } else if (egumaReact.isAllDay && egumaReact.hasMultipleCapacities) {
          this.getCapacities({ slotId: timeSlots[0].id }, scrollTo);
          this.setState({ selectedTimeSlot: timeSlots[0].id });
          return;
        }

        if (scrollTo) {
          scroller.scrollTo("timeSlots", {
            duration: 300,
            smooth: true,
            offset: -20
          });
        }
      });
    } catch (error) {
      console.log(error);
      this.setState({
        fetchingTimeSlots: false
      });
    }
  };

  runCustomValidator() {
    try {
      if (typeof window.onCalendarValidate !== "undefined") {
        const lineItems = [];

        for (let ticket of this.state.tickets) {
          const sel = this.state.selectedTickets[ticket.id];
          if (sel === undefined) {
            continue;
          }

          const qty = parseInt(this.state.selectedTickets[ticket.id], 10);
          if (qty > 0) {
            lineItems.push({ id: ticket.id, name: ticket.name, qty: qty });
          }
        }

        return window.onCalendarValidate(egumaReact.eventId, lineItems);
      }
    } catch (error) {
      console.error(error);
      alert("Es ist ein Fehler aufgetreten.");
      return false;
    }

    return true;
  }

  onContinue = async e => {
    e.preventDefault();
    this.setState({ newTickets: [] });

    const selectedTickets = Object.keys(this.state.selectedTickets);

    if (selectedTickets.length <= 0) {
      this.setState(
        {
          error: polyglot.t("Shop.Error.NoTicketSelected")
        },
        () => {
          scroller.scrollTo("error", {
            duration: 300,
            smooth: true,
            offset: -20
          });
        }
      );
      return;
    }

    if (!this.runCustomValidator()) {
      return;
    }

    const note = this.refNote.current.getNote();

    if (egumaReact.noteEnabled && egumaReact.noteMandatory && note === "") {
      this.setState(
        {
          error: egumaReact.noteMandatoryMessage
        },
        () => {
          scroller.scrollTo("error", {
            duration: 300,
            smooth: true,
            offset: -20
          });
        }
      );

      return;
    }

    const payload = {
      eventId: egumaReact.eventId,
      slotId: this.state.selectedTimeSlot,
      capacityId: this.state.selectedCapacity,
      tickets: selectedTickets.map(id => ({
        id,
        quantity: this.state.selectedTickets[id]
      })),
      note: note
    };

    const data = await client(
      `/api/${egumaReact.mandantId}/${egumaReact.lang}/add_time_slot_tickets`,
      { body: payload }
    );

    if (data.success) {
      window.location.href = data.redirect;
    } else {
      this.setState({ error: data.message, newTickets: [] }, () => {
        scroller.scrollTo("error", {
          duration: 300,
          smooth: true,
          offset: -20
        });
      });
    }
  };

  onTicketTypeChange = (ticketTypeId, quantity) => {
    const newSelectedTickets = {
      ...this.state.selectedTickets
    };
    if (parseInt(quantity, 10) <= 0) {
      delete newSelectedTickets[ticketTypeId];
    } else {
      newSelectedTickets[ticketTypeId] = quantity;
    }
    this.setState({ selectedTickets: newSelectedTickets });
  };

  appliedPromocode = async newTickets => {
    if (this.state.selectedCapacity) {
      await this.getTickets({
        slotId: this.state.selectedTimeSlot,
        capacityId: this.state.selectedCapacity
      });
    } else if (this.state.selectedTimeSlot) {
      await this.getCapacities({ slotId: this.state.selectedTimeSlot });
    } else if (this.state.date) {
      await this.getTimeSlots();
    }

    this.setState({ newTickets });
  };

  getPromocodeMessage = () => {
    if (egumaReact.isAllDay) {
      return polyglot.t(
        "Core.Promocode.YouHaveUnlockedFollowingCategories.Hint.CalendarAllDay"
      );
    } else {
      return polyglot.t(
        "Core.Promocode.YouHaveUnlockedFollowingCategories.Hint.CalendarTimeSlot"
      );
    }
  };

  render() {
    const {
      availableDates,
      entirelyBookedDates,
      fetchingDates,
      fetchingTimeSlots,
      fetchingCapacities,
      selectedTickets,
      tickets,
      newTickets,
      groups,
      date
    } = this.state;

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-lg-10">
            <div id="select-date" style={{ marginTop: 30, marginBottom: 20 }}>
              {polyglot.t("Backend.Ticketing.Calendar.PleaseChooseDate")}
            </div>
            <div style={{ position: "relative", width: "fit-content" }}>
              {fetchingDates && (
                <div
                  style={{
                    position: "absolute",
                    zIndex: 100,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    backgroundColor: "rgba(255, 255, 255, 0.7)"
                  }}
                >
                  <DotLoader
                    sizeUnit={"px"}
                    size={70}
                    color={"rgba(55, 55, 55, 0.9)"}
                    loading={true}
                  />
                </div>
              )}

              <DayPickerSingleDateController
                focused
                initialVisibleMonth={() =>
                  availableDates.size > 0
                    ? moment(availableDates.values().next().value)
                    : moment()
                }
                date={date}
                onDateChange={this.onChangeDate}
                isOutsideRange={d =>
                  !availableDates.has(d.format("YYYY-MM-DD"))
                }
                isDayBlocked={d =>
                  !(egumaReact.isWaitingList && egumaReact.isAllDay) &&
                  entirelyBookedDates.has(d.format("YYYY-MM-DD"))
                }
                isDayHighlighted={d => {
                  return false;
                }}
                onNextMonthClick={this.getDates}
                onPrevMonthClick={this.getDates}
              />
            </div>

            {!fetchingTimeSlots && (
              <TimeSlots
                currentDate={this.state.date}
                onSelect={this.getCapacities}
                selectedTimeSlot={this.state.selectedTimeSlot}
                timeSlots={this.state.timeSlots}
                hasPromocodeForm={egumaReact.userCanEnterPromocode}
              />
            )}

            {!fetchingCapacities && (
              <Capacities
                capacities={this.state.capacities}
                selectedTimeSlot={this.state.selectedTimeSlot}
                selectedCapacity={this.state.selectedCapacity}
                onSelect={this.getTickets}
              />
            )}

            {this.state.date &&
            egumaReact.isAllDay &&
            egumaReact.isWaitingList &&
            entirelyBookedDates.has(this.state.date.format("YYYY-MM-DD")) ? (
              <div
                className="border-color"
                style={{
                  borderStyle: "solid",
                  borderWidth: 2,
                  fontWeight: "bold",
                  padding: 10,
                  marginTop: 20,
                  marginBottom: 0
                }}
              >
                <span
                  dangerouslySetInnerHTML={{
                    __html: polyglot.t(
                      "Shop.Ticketing.WaitingListIsAvailable.HintCalendar",
                      {
                        link: `${window.location.pathname}/waitinglist?slotId=${this.state.selectedTimeSlot}`
                      }
                    )
                  }}
                />
              </div>
            ) : (
              <form onSubmit={this.onContinue}>
                <Element name="tickets">
                  {newTickets.length > 0 && (
                    <div
                      className="product-promocode-by-url-applied"
                      style={{ marginTop: 20, marginBottom: 0 }}
                    >
                      {polyglot.t(
                        "Core.Promocode.YouHaveUnlockedFollowingCategories"
                      )}
                      <ul style={{ marginTop: 10, marginBottom: 0 }}>
                        {newTickets.map(n => (
                          <li key={n.name}>{n.name}</li>
                        ))}
                      </ul>

                      <div style={{ marginTop: 10 }}>
                        {this.getPromocodeMessage()}
                      </div>
                    </div>
                  )}

                  {this.state.error && <Error message={this.state.error} />}

                  {groups.length === 0 ? (
                    <Tickets
                      handleChange={this.onTicketTypeChange}
                      selectedTickets={selectedTickets}
                      tickets={tickets}
                    />
                  ) : (
                    <TicketsAccordion
                      handleChange={this.onTicketTypeChange}
                      selectedTickets={selectedTickets}
                      tickets={tickets}
                      groups={groups}
                    />
                  )}
                </Element>

                {this.state.tickets.length > 0 && <Note ref={this.refNote} />}

                {egumaReact.userCanEnterPromocode && (
                  <PromocodeForm callback={this.appliedPromocode} />
                )}

                {this.state.tickets.length > 0 && (
                  <PrimaryButton
                    fullWidth
                    style={{ marginTop: 40 }}
                    type="submit"
                  >
                    {polyglot.t("Shop.Action.Next")}
                  </PrimaryButton>
                )}
              </form>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default App;
